module.exports = __webpack_public_path__ + "img/示例图_6.a1433e6a.png";